/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 * https://ionicframework.com/docs/ja/troubleshooting/runtime#angular-change-detection
 */
// eslint-disable-next-line no-underscore-dangle
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__Zone_disable_customElements = true;
